import { useColorScheme } from '@/hooks/useColorScheme';

export const useLoaderBackground = (style = null) => {
    const colorTheme = useColorScheme();
    
    return {
        ...style,
        backgroundColor: colorTheme === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.75)'
    }
}